import React, {ReactElement, useEffect, useState} from 'react';
import RupeesIcon from '../../../assets/images/rupees.svg';
import {useAppSelector} from '../../../redux/hooks';
import RupeesIconBlue from '../../../assets/images/rupee_blue.svg';
import {OrderResponse, ItemListType} from '../../../lib/order-types';
import {getMetadata, getUser} from '../../../core/localstorage-data';
import {lmrCheckedData} from '../../../redux/orderSlice';

type ProductCardProps = {
  type?: string;
  onDelete?: (item: ItemListType) => void;
  orderResp: OrderResponse;
  priceDetails?: any;
};
const ProductCard: React.FC<ProductCardProps> = ({
  type,
  onDelete,
  orderResp,
  priceDetails,
}: ProductCardProps): ReactElement => {
  let BAG_PRICE = 0;
  const lmrChecked = useAppSelector(lmrCheckedData);
  const customerProfileData = getUser();
  const metaData = getMetadata();
  const bagMetaData = metaData.find(
    (obj: {name: string}) => obj.name === 'bag-price',
  );
  if (bagMetaData) {
    BAG_PRICE = bagMetaData.value;
  }
  function renderProductCard() {
    return (
      orderResp &&
      orderResp.itemList &&
      orderResp.itemList.map((item, index) => {
        return (
          <div
            className="p-4 font-roboto shadow-max mb-2 rounded-radius10"
            key={index}>
            <div className="flex justify-between bg-white backdrop-blur mb-2 font-medium">
              <div className=" text-base">Max fashion</div>

              {item.sellPrice !== item.extSellPrice ? (
                <div className="flex justify-between items-center">
                  <strike>
                    <span className="text-black_zero opacity-30 text-xxs flex justify-start">
                      {<img src={RupeesIcon} />}
                      <span className="ml-1">{item.sellPrice.toFixed(2)}</span>
                    </span>
                  </strike>
                  <span className="flex ml-1">
                    <img src={RupeesIcon} />
                    <span className="ml-1">{item.extSellPrice.toFixed(2)}</span>
                  </span>
                </div>
              ) : (
                <div>
                  <span className="flex ml-1">
                    {<img src={RupeesIcon} />}{' '}
                    <span className="ml-1">{item.sellPrice.toFixed(2)}</span>
                  </span>
                </div>
              )}
            </div>
            <div className="flex justify-between mb-2">
              <div className="text-small w-3/6">{item.itemDesc}</div>
              <div className="flex flex-col text-tiny">
                {item.itemColour && <span>Color: {item.itemColour}</span>}
                {item.itemSize && <span>Size: {item.itemSize}</span>}
              </div>
            </div>
            <div className="border-solid border-gray-300 border-1 mb-2.5"></div>
            <div className="flex justify-between bg-white backdrop-blur mb-2 font-medium">
              <div className="text-tiny">Quantity: {item.quantity}</div>
              <div
                className="text-red_zero font-bold text-small"
                onClick={() => onDelete(item)}>
                Delete
              </div>
            </div>
          </div>
        );
      })
    );
  }

  function renderPriceDetailCard() {
    let totalMRP = 0;
    let promoDiscountAmount = 0;
    let bagPrice = 0;
    orderResp &&
      orderResp.itemList &&
      orderResp.itemList.forEach(item => {
        totalMRP += item.sellPrice;
        promoDiscountAmount += item.promoDiscountAmount;
      });
    if (orderResp && orderResp.carryBagItem) {
      bagPrice = BAG_PRICE * orderResp.carryBagItem.quantity;
    }
    let couponTotalDiscount = 0;
    orderResp &&
      orderResp.itemList &&
      orderResp.itemList.forEach(item => {
        if (item.couponDiscountAmount) {
          couponTotalDiscount += item.couponDiscountAmount;
        }
      });
    // let freeBiePrice = 0;
    // if (orderResp && orderResp.selectedFreeBie) {
    //   freeBiePrice += orderResp.selectedFreeBie.extSellPrice;
    // }
    let lmrRewardsPrice = 0;
    if (lmrChecked) {
      if (priceDetails) {
        lmrRewardsPrice = priceDetails.lmrRewardsPrice;
      } else {
        lmrRewardsPrice = customerProfileData.pointsAvailable * 0.6;
      }
    } else {
      lmrRewardsPrice = 0;
    }

    let totalAmount =
      orderResp && orderResp.itemList
        ? orderResp.itemList.reduce((prevAmount, item) => {
            return prevAmount + item.extSellPrice;
          }, 0)
        : 0;
    if (priceDetails) {
      totalAmount = priceDetails.totalAmount;
    } else {
      totalAmount = totalAmount + bagPrice - lmrRewardsPrice;
    }

    return (
      <div className="font-roboto ">
        <div className="p-4 shadow-max rounded-radius10">
          <div className="flex justify-between bg-white backdrop-blur mb-2 font-medium ">
            <div className=" text-base font-medium">
              Price details
              <span className="text-small">
                {' '}
                ({orderResp &&
                  orderResp.itemList &&
                  orderResp.itemList.length}{' '}
                {orderResp &&
                orderResp.itemList &&
                orderResp.itemList.length &&
                orderResp.itemList.length > 1
                  ? 'items'
                  : 'item'}
                )
              </span>
            </div>
          </div>
          <div className="flex font-roboto justify-between mb-2">
            <div className="text-small">Total MRP</div>
            <div className="text-small flex items-center">
              <img src={RupeesIcon} style={{height: '10px', width: '10px'}} />
              <span className="ml-1">{totalMRP.toFixed(2)}</span>
            </div>
          </div>
          <div className="flex justify-between mb-2">
            {promoDiscountAmount > 0 && (
              <>
                <div className="text-small">Additional discount</div>
                <div className="text-small flex items-center">
                  <span className="mr-1">–</span>
                  <img
                    src={RupeesIcon}
                    style={{height: '10px', width: '10px'}}
                  />
                  <span className="ml-1">{promoDiscountAmount.toFixed(2)}</span>
                </div>
              </>
            )}
          </div>
          {couponTotalDiscount > 0 && (
            <div className="flex justify-between mb-2 text-royal_blue">
              <div className="text-small">Coupon discount</div>

              <div className="text-small flex items-center">
                <span className="mr-1">–</span>
                <img
                  src={RupeesIconBlue}
                  style={{height: '10px', width: '10px'}}
                />
                <span className="ml-1">{couponTotalDiscount.toFixed(2)}</span>
              </div>
            </div>
          )}
          {bagPrice > 0 && (
            <div className="flex justify-between mb-2">
              <div className="text-small">Bag</div>

              <div className="text-small flex items-center">
                <img src={RupeesIcon} style={{height: '10px', width: '10px'}} />
                <span className="ml-1">{bagPrice}</span>
              </div>
            </div>
          )}

          {lmrChecked && lmrRewardsPrice > 0 && (
            <div className="flex justify-between mb-2">
              <div className="text-small">LMR Points</div>

              <div className="text-small flex items-center">
                <img src={RupeesIcon} style={{height: '10px', width: '10px'}} />
                <span className="ml-1">{lmrRewardsPrice.toFixed(2)}</span>
              </div>
            </div>
          )}
          <div className="border-solid border-gray-300 border-1 mb-2.5"></div>
          <div className="flex justify-between bg-white backdrop-blur mb-2 text-base font-medium">
            <div className="">Total amount</div>
            <div className="flex items-center">
              <img src={RupeesIcon} />
              <span className="ml-1">{totalAmount.toFixed(2)}</span>
            </div>
          </div>
        </div>
      </div>
    );
  }

  if (orderResp === null) {
    return <div></div>;
  } else {
    return (
      <div>
        {type === 'product' ? renderProductCard() : renderPriceDetailCard()}
      </div>
    );
  }
};
export default ProductCard;
